
    import { Component, Vue, Prop } from 'vue-property-decorator'

    @Component
    export default class SimpleTable extends Vue {
        @Prop({ type: Boolean, default: false }) fixedHeader!: boolean
        @Prop({ type: Boolean, default: false }) dense!: boolean
        @Prop({ type: Boolean, default: false }) withHover!: boolean
    }
